// extracted by mini-css-extract-plugin
export default {"mainToolbar":"Nav_mainToolbar__gplqx","lastContainer":"Nav_lastContainer__5LcSN"};